import { combineReducers } from 'redux';
import locale from './locale/locale';

const reducers = combineReducers({
  locale,
});

export default reducers;



// WEBPACK FOOTER //
// ./src/reducers/reducers.js